import { render, staticRenderFns } from "./FeaturesFromGroup.vue?vue&type=template&id=82742df4&"
import script from "./FeaturesFromGroup.vue?vue&type=script&lang=js&"
export * from "./FeaturesFromGroup.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesFromGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports